import { render, staticRenderFns } from "./PromotionOtherForm.vue?vue&type=template&id=130c3960&scoped=true&"
import script from "./PromotionOtherForm.vue?vue&type=script&lang=js&"
export * from "./PromotionOtherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c3960",
  null
  
)

export default component.exports